import React, {useState} from 'react';
import './assets/styles/App.css';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import {Home} from "./views/home";
import {Header} from "./components/header";
import {Application} from "./views/application";
import {AlertProvider} from "./hooks/AlertContext";
import {GlobalRouterPath} from "./constants";
import {AIRemover} from "./views/my_tools/ai_remover";
import {AIInPaint} from "./views/my_tools/ai_inpaint";
import {ImgCompressor} from "./views/my_tools/img_compressor";
import {AiEnhancer} from "./views/my_tools/ai_enhancer";
import {NotificationProvider} from "./hooks/NotificationContext";
import {AiVideoEnhancer} from "./views/my_tools/ai_video_enhancer";
import {VideoConvert} from "./views/my_tools/video_convert";

// 判断是否为移动端
const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

function App() {
    const [isLight, setIsLight] = useState(true);
    const [globalBgColor, setGlobalBgColor] = useState('#f6f7f9');
    const [globalTextColor, setGlobalTextColor] = useState('#ffffff');

    const mainClassName = `App-Main bg-[${globalBgColor}] text-[${globalTextColor}]`;

    const setCurGlobalBg = () => {
        setIsLight((prev) => {
            setGlobalBgColor(!prev ? '#f6f7f9' : '#242526');
            setGlobalTextColor(!prev ? '#aaaaaa' : '#f6f7f9')
            return !prev;
        });
    }

    return (
        <div className="App">
            <AlertProvider>
                <NotificationProvider>
                    <header>
                        <Header
                            isLight={isLight}
                            setIsLight={setCurGlobalBg}
                        />
                    </header>
                    <main className={mainClassName}>
                        <BrowserRouter>
                            <Routes>
                                <Route path={GlobalRouterPath.HOME} element={
                                        <Home globalTextColor={globalTextColor} isLight={isLight}/>
                                }/>

                                {/*tools*/}
                                <Route path={GlobalRouterPath.IMAGE_REMOVE_BG} element={
                                    <AlertProvider>
                                        <AIRemover globalTextColor={globalTextColor} isLight={isLight}/>
                                    </AlertProvider>
                                }/>
                                <Route path={GlobalRouterPath.IMAGE_IN_PAINT} element={
                                    <AlertProvider>
                                        <AIInPaint globalTextColor={globalTextColor}/>
                                    </AlertProvider>
                                }/>
                                <Route path={GlobalRouterPath.IMAGE_ENHANCE} element={
                                    <AlertProvider>
                                        <AiEnhancer globalTextColor={globalTextColor}/>
                                    </AlertProvider>
                                }/>
                                {/*<Route path={GlobalRouterPath.VIDEO_ENHANCE} element={*/}
                                {/*    <AlertProvider>*/}
                                {/*        <AiVideoEnhancer globalTextColor={globalTextColor}/>*/}
                                {/*    </AlertProvider>*/}
                                {/*}/>*/}
                                <Route path={GlobalRouterPath.IMAGE_COMPRESSOR} element={
                                    <AlertProvider>
                                        <ImgCompressor globalTextColor={globalTextColor}/>
                                    </AlertProvider>
                                }/>
                                <Route path={GlobalRouterPath.VIDEO_CONVERT} element={
                                    <AlertProvider>
                                        <VideoConvert globalTextColor={globalTextColor}/>
                                    </AlertProvider>
                                }/>


                                <Route path={GlobalRouterPath.APPLICATION} element={
                                    <AlertProvider>
                                        <Application globalTextColor={globalTextColor}/>
                                    </AlertProvider>
                                }/>
                            </Routes>
                        </BrowserRouter>
                    </main>
                </NotificationProvider>
            </AlertProvider>
        </div>
    );
}

export default App;
